import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'components/base';

const CartAlerts = props => (
  <>
    {props.alerts.map(alert => (
      <Alert key={alert.message} type={alert.type} className="mb-1">
        <div className="cart-alert-content" dangerouslySetInnerHTML={{ __html: alert.message }} />
      </Alert>
    ))}
  </>
);

CartAlerts.propTypes = {
  alerts: PropTypes.array,
};

CartAlerts.defaultProps = {
  alerts: [],
};

export default CartAlerts;
